import { Component, DoCheck } from '@angular/core';
import { BrowserService } from 'src/app/core';

@Component({
  selector: 'footer',
  templateUrl: './footer.component.html',
})
export class FooterComponent implements DoCheck {
  year: number = 0;
  pathname: string = '';
  isBrowser!: boolean;
  // isLogin: boolean = false;

  constructor(private _browserService: BrowserService) {}
  ngDoCheck() {
    this.isBrowser = this._browserService.checkBrowser();
    if (this.isBrowser) {
      const siteSrc = window.location.href;
      const urlData = siteSrc.split('/');
      const mediaPath = urlData[3].split('?');
      if (urlData[4] && urlData[4] == 'bah') {
        this.pathname = 'media';
      } else if (urlData[4] && urlData[4].includes('pay-calculator')) {
        this.pathname = 'pay-calculator';
      } else {
        this.pathname = mediaPath[0];
      }
    }
  }
  ngOnInit(): void {
    const date = new Date();
    this.year = date.getFullYear();
  }
}
